<ng-container *transloco="let t; read: 'form-editor'">
  <button
    *ngIf="isInsideDialog"
    class="form-editor__close-button p-button-rounded p-button-secondary p-button-text"
    icon="pi pi-times"
    pButton
    type="button"
    [attr.aria-label]="t('closeDialogButtonLabel')"
    (click)="onCloseDialogClicked()"
  ></button>

  <ng-container *ngIf="data$ | async as data; else loading">
    <survey-creator [model]="data.creatorModel"></survey-creator>
    <app-audit-entry [auditEntry]="data.auditEntry"> </app-audit-entry>
  </ng-container>
</ng-container>

<ng-template #loading>
  <div class="form-editor__loading-overlay">
    <app-progress-spinner></app-progress-spinner>
  </div>
</ng-template>

<p-confirmDialog></p-confirmDialog>
